import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Header from "components/FrontEnd/Header/Header";
import FrontEndRoutes from "routes/FrontEndRoutes.jsx";
import { connect } from 'react-redux'
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/fonts/sourceSansPro.css";
import "../../assets/css/owl.carousel.css";
import "../../assets/css/owl.theme.css";
import "../../assets/css/owl.transitions.css";
import "../../assets/css/reset.css";
import "../../assets/css/style.css";
import MessageCom from "../Dashboard/Message";
import { loadProgressBar } from 'axios-progress-bar'
import User from "../../helper/User";
import { alertActions } from "../../redux/actions/alert-actions";

class Frontend extends Component {
  constructor(props) {
    super(props)

    this.state = {

    }
    this.redirect = this.redirect.bind(this);
  }

  redirect() {
    this.props.sendNotification();
    return <Redirect to='/dashboard' />;
  }
  render() {
    return (
      <div className="section-frontEnd">
        
        <Header {...this.props} />
        <h1 className="text-center text-lg mt-xlg">Welcome</h1>

        <p className="text-center text-sm mt-md">Please login to continue.</p>

        <MessageCom />
        {
          loadProgressBar()
        }
        <div className="" ref="mainPanel">
          <Switch>
            {
              FrontEndRoutes.map((prop, key) => {
                if ('auth' in prop) {
                  return (
                    <Route path={prop.path} component={
                      User.isAuthenticated() === true ?
                        'role' in prop ? User.hasRole(prop.role) === true ? prop.component : () => this.redirect() :
                          prop.component
                        :
                        () => <Redirect to='/login' />
                    } key={key} />
                  )
                } else {
                  return (
                    <Route path={prop.path} component={prop.component} key={key} />
                  );
                }
              })
            }
          </Switch>
          {/* <Footer /> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { User } = state.frontEndUserReducer;
  return {
    User
  }
}

const mapDispatchToProps = dispatch => {
  return {
    sendNotification: () => { dispatch(alertActions.error('You dont have permission to access this page')) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Frontend);



// WEBPACK FOOTER //
// ./src/layouts/Frontend/Frontend.jsx